/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddNoteAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import HelpTooltip from './HelpTooltip/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconDescription from 'DesignSystem/Svgs/TysiaIconDescription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AddNoteAction({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/AddNoteAction",
  hovered,
  onMouseEnter,
  onMouseLeave
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  hovered,
  onMouseEnter,
  onMouseLeave
  
})
  return (<React.Fragment
>
<div
  data-testid="AddNoteAction.Horizontal"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-ZN5aRy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="auto"
 onClick={onClick}
 type="secondary"
 size="small"
 title="Add new appointment note"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconDescription
{...childProps}
  viewPath={`${viewPath}/TysiaIconDescription`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<HelpTooltip
  viewPath={`${viewPath}/HelpTooltip`}
 hovered={hovered}
/>
</div>
{children}
</React.Fragment>)
}